import { Table } from 'antd/lib'
import { useEffect, useState } from 'react'
import { CloudDownloadOutlined } from '@ant-design/icons'
import styles from './index.module.scss'
import { useNavigate } from 'react-router'

const AdminPage = () => {
  const downloadFile = async (id) => {
    let anchor = document.createElement('a')
    document.body.appendChild(anchor)

    let file = `/api/admin/tender/file/${id}`
    // https://mosinfobez.ru
    let headers = new Headers()
    const token = localStorage.getItem('admin_rme_token')
    headers.append('Authorization', `Bearer ${token}`)

    const response = await fetch(file, { headers })
    const filename = response.headers.get('File-Name')

    response.blob().then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby)

      anchor.href = objectUrl
      anchor.download = filename
      anchor.click()

      window.URL.revokeObjectURL(objectUrl)
    })
  }
  const columns = [
    {
      title: 'Имя',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Телефон',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Закон',
      dataIndex: 'law',
      key: 'law',
    },
    {
      title: 'Комментарий',
      dataIndex: 'comment',
      key: 'comment',
    },
    {
      title: 'Файлы',
      dataIndex: 'files',
      key: 'files',
      render: (_, { files }) => (
        <>
          {files.map((file) => (
            <CloudDownloadOutlined onClick={() => downloadFile(file)} key={`file_${file}`} className={styles.download} />
          ))}
        </>
      ),
    },
    {
      title: 'Отправлено',
      dataIndex: 'creationTimestamp',
      key: 'creationTimestamp',
      render: (_, { creationTimestamp }) => <span>{new Date(creationTimestamp).toLocaleString('ru-RU')}</span>,
    },
  ]

  const columnsRequest = [
    {
      title: 'Имя',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Телефон',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Комментарий',
      dataIndex: 'comment',
      key: 'comment',
    },
    {
      title: 'Отправлено',
      dataIndex: 'creationTimestamp',
      key: 'creationTimestamp',
      render: (_, { creationTimestamp }) => <span>{new Date(creationTimestamp).toLocaleString('ru-RU')}</span>,
    },
  ]

  const [tableData, setData] = useState()
  const [tableDataRequest, setDataRequest] = useState()
  const navigate = useNavigate()

  const fetchData = async () => {
    const token = localStorage.getItem('admin_rme_token')
    const response = await fetch('/api/admin/tender/all', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => res.json())
    console.log(response)
    setData(response)
  }

  const fetchDataRequest = async () => {
    const token = localStorage.getItem('admin_rme_token')
    const response = await fetch('/api/admin/request/all', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => res.json())
    console.log(response)
    setDataRequest(response)
  }

  useEffect(() => {
    if (!localStorage.getItem('admin_rme_token')) return navigate('/admin/login')
    fetchData()
    fetchDataRequest()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.page}>
      {tableData ? (
        <Table columns={columns} rowKey={(row) => row.creationTimestamp} dataSource={tableData} className={styles.form} />
      ) : (
        <div>Ошибка</div>
      )}
      {tableDataRequest ? (
        <Table columns={columnsRequest} rowKey={(row) => row.creationTimestamp} dataSource={tableDataRequest} className={styles.form} />
      ) : (
        <div>Ошибка</div>
      )}
    </div>
  )
}

export { AdminPage }
